import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import * as moment from 'moment';
import 'moment-timezone';
import { AppFacade } from '../../store/state/app/app.facade';
import { AuthFacade } from '../../store/state/auth/auth.facade';
import {
  LOCALE_CODE_LIST,
  LOCALE_SHORT_DISPLAY_DATE_FORMAT,
  Language,
  TIME_12HOUR_FORMAT,
  TIME_SHORT_FORMAT,
  UNKNOWN,
} from '../constants';
import { AutoUnsubscribe } from '../decorators';
import { Subscription } from 'rxjs';
import { isNil } from 'lodash';
import { isGmtOffsetFormat } from '../utils';

@Pipe({
    name: 'locale', pure: false,
    standalone: false
})
@AutoUnsubscribe
export class LocalePipe implements PipeTransform {
  private timezone: string;
  private localeValue: string;
  private timeFormat: string;
  private dateFormat: string;
  private subscription: Subscription[] = [];

  constructor(private authFacade: AuthFacade, private cd: ChangeDetectorRef, private appFacade: AppFacade) {
    this.subscription.push(
      this.appFacade.currentLanguage$.pipe(filter(Boolean)).subscribe((language: Language) => {
        this.localeValue = LOCALE_CODE_LIST[language];
        this.cd.markForCheck();
      }),
      this.authFacade.timezone$.pipe(take(1)).subscribe((timezone: string) => {
        this.timezone = timezone;
      }),
      this.authFacade.isTwentyFourHourTime$.pipe(take(1)).subscribe((isTwentyFourHourTime: boolean) => {
        this.timeFormat = isTwentyFourHourTime ? TIME_SHORT_FORMAT : TIME_12HOUR_FORMAT;
        this.dateFormat = `${LOCALE_SHORT_DISPLAY_DATE_FORMAT} ${this.timeFormat} `;
      }),
    );
  }

  transform(
    date: moment.MomentInput,
    dateFormat: string = this.dateFormat,
    timezoneOverride: string = this.timezone,
    localeValue: string = this.localeValue,
    offset: string = null,
  ): string | moment.MomentInput {
    const format = isNil(dateFormat) || dateFormat === '' ? this.dateFormat : dateFormat;
    const locale = localeValue ? localeValue : this.localeValue;

    if (date && (!timezoneOverride || timezoneOverride?.toUpperCase() === UNKNOWN)) {
      return moment(date).locale(locale).format(format);
    }

    if (timezoneOverride && isGmtOffsetFormat(timezoneOverride) && date && offset) {
      return moment.utc(date).utcOffset(offset).format(format);
    }

    if (date) {
      return moment.tz(moment(date).locale(locale), timezoneOverride).format(format).trim();
    }

    return date;
  }
}
